import styled from '@emotion/styled';
import Image from '@base/Image';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import { Spacings } from '@styles/index';
import { COMBAT_TYPES } from '../constants';

const EmptyIcon = 'combat/empty.svg';

const Wrapper = styled.div`
  grid-column: span 18;
  min-height: 470px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Head = styled(H4)`
  margin: ${Spacings.SPACING_6B} 0px ${Spacings.SPACING_2B} 0px;
`;

const Empty = ({ type }) => {
  const getInfo = () => {
    if (type === COMBAT_TYPES.UPCOMING) {
      return {
        head: 'No upcoming combats',
        description: 'Upcoming combats will show up here'
      };
    }

    if (type === COMBAT_TYPES.PAST) {
      return {
        head: 'No past combats',
        description: 'Past combats will show up here'
      };
    }

    return {
      head: 'No combats',
      description: 'Combats will show up here'
    };
  };

  const { head, description } = getInfo();

  return (
    <Wrapper>
      <Image src={EmptyIcon} alt="emptystate-combat" height={120} width={120} />
      <Head>{head}</Head>
      <P1 color="var(--color-text-secondary)">{description}</P1>
    </Wrapper>
  );
};

export default Empty;
